<div class="workspace-container" [class.sidebar-collapsed]="effectiveSidebarCollapsed"
  [class.mobile-menu-open]="isMobileMenuOpen">

  <!-- Mobile Backdrop Overlay -->
  <div class="mobile-backdrop" (click)="toggleMobileMenu()"></div>

  <!-- LEFT SIDEBAR PANEL -->
  <aside class="sidebar" *ngIf="!isCompanyOnboardPage && isAuthenticated">
    <app-recruiter-sidebar [isCollapsed]="effectiveSidebarCollapsed" [activeTab]="activeTab"
      (activeTabChange)="setActiveTab($event)" (toggleCollapse)="toggleSidebar()" (logout)="logout()">
    </app-recruiter-sidebar>
  </aside>

  <!-- MAIN WORKSPACE CONTAINER -->
  <main class="main-content" [class.full-width]="isCompanyOnboardPage || !isAuthenticated">

    <!-- HEADER BAR -->
    <app-recruiter-header *ngIf="!isCompanyOnboardPage && isAuthenticated" [isSidebarCollapsed]="effectiveSidebarCollapsed"
      (toggleMobileMenu)="toggleMobileMenu()" (globalSearch)="onGlobalSearch($event)" (logout)="logout()"
      (navigateToTab)="setActiveTab($event)">
    </app-recruiter-header>

    <!-- CONTENT BODY CONTAINER -->
    <div class="content-wrapper">

      <!-- Nested Router Outlet for modular subcomponents -->
      <router-outlet></router-outlet>

      <!-- TAB 5 & 6 FALLBACK INTERVIEW SECTIONS -->
      <ng-container *ngIf="activeTab === 'interview' || activeTab === 'one_one_interview'">
        <div class="view-header">
          <h1 class="view-title">{{ activeTab === 'interview' ? 'AI Interview Sessions' : '1:1 Technical Interviews' }}
          </h1>
          <p class="view-subtitle">Review scheduled meeting calls and candidate AI recordings</p>
        </div>

        <div class="empty-state-panel">
          <div class="empty-state-graphic">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"
              class="empty-icon">
              <path
                d="M23 7a2 2 0 0 0-2.45-1.45L16 7V5a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2l4.55 1.45A2 2 0 0 0 23 17V7z" />
            </svg>
          </div>
          <h3>No Ongoing Live Interviews</h3>
          <p>Schedule your first live technical session or send AI interview triggers from the Candidates tab to get
            started.</p>
          <button class="primary-btn" (click)="setActiveTab('candidates')">
            Go to Candidates
          </button>
        </div>
      </ng-container>

    </div>
  </main>
</div>

<!-- Pending Approval Modal -->
<div class="modal-overlay" *ngIf="showPendingModal"
  style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5); display: flex; align-items: center; justify-content: center; z-index: 9999; padding: 1rem;">
  <div class="modal-container pending-modal"
    style="background: var(--white, #fff); border-radius: 0.5rem; width: 100%; max-width: 500px; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15); position: relative;">


    <div class="modal-body text-center"
      style="display: flex; flex-direction: column; align-items: center; text-align: center; padding: 2.5rem 2rem 2rem;">

      <!-- Icon at Top -->
      <div class="pending-icon-box"
        style="background-color: var(--button-blue, #1d1b84); width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 1.25rem; color: white;">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
      </div>

      <h2 class="modal-title"
        style="margin-bottom: 0.75rem; font-size: 1.25rem; font-weight: 600; color: var(--semname-black, #111827);">Your
        company account is under review</h2>

      <p class="modal-subtitle"
        style="margin-bottom: 1.5rem; line-height: 1.5; font-size: 0.875rem; color: var(--cardText-grey, #6b7280);">
        The BeExpert admin team will review and approve your request shortly.<br>
        You'll be notified on your company email <strong style="color: var(--semname-black, #111827);">{{
          registeredEmail }}</strong> once your account is approved.
      </p>

      <div class="status-badge"
        style="background-color: #fef3c7; color: #d97706; padding: 0.375rem 1rem; border-radius: 1rem; font-size: 0.75rem; font-weight: 600; display: inline-flex; align-items: center; gap: 0.375rem; margin-bottom: 1.75rem;">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
        Pending Approval
      </div>

      <div class="divider"
        style="width: 100%; border-top: 1px solid var(--cloud-gray, #e5e7eb); margin-bottom: 1.5rem;"></div>

      <button class="btn-submit-confirm"
        style="width: 100%; justify-content: center; background-color: var(--button-blue, #1d1b84); color: white; border: none; border-radius: 0.375rem; padding: 0.75rem 1.5rem; font-size: 0.875rem; font-weight: 500; cursor: pointer;"
        (click)="logout()">
        Logout
      </button>
    </div>
  </div>
</div>